import http from "@/api/http";
export default {
  selectByCondition(params){
    return http.get("/server/small-purchase/list","form",params);
  },
  addOrUpdate(param){
    return http.post("/server/small-purchase/submit","json",param);
  },
}
